import React from "react";
import { Box, Typography } from "@mui/material";
// import UserListModaledit from "./UserListModaledit";
import { makeStyles } from "@mui/styles";
import { ChangeDate } from "../../helpers/Date";

const Chapterdetailtable = ({ no, item, render, setRender,chapter }) => {
  const classes = useStyles();
  console.log("item2",item)
  console.log("chapter",chapter)
  return (
    <>
      <Box
        sx={{
          display: "flex",
          background: "#fff",
          color: "#fff",
          // height: "45px",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            width: "70px",
            display: "flex",
            color: "#fff",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          {no + 1}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          {chapter?.chapter?.name}
        </Typography>
        <div></div>
        <Typography
          sx={{
            width: "400px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          {chapter?.chapter?.description}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          {item?.name}
        </Typography>
        <Typography
          sx={{
            width: "180px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderRight: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item?.link}
        </Typography>
      </Box>
    </>
  );
};

const useStyles = makeStyles({
  image: {
    width: "100%",
  },
});

export default Chapterdetailtable;
